// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Hero.css */
:root {
  --green: #7ED321;
  --blue: #2C3E50;
  --bg: #F5F8FB;
}

.hero {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  padding: 140px 8vw 20px;
  text-align: center;
  max-width: 1100px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg {
  position: fixed;
  inset: 0;
  z-index: -1;
  background:
    radial-gradient(1200px 800px at 20% 15%, rgba(126, 211, 33, 0.35), transparent 55%),
    radial-gradient(1100px 900px at 80% 25%, rgba(44, 62, 80, 0.28), transparent 55%),
    radial-gradient(900px 700px at 50% 80%, rgba(126, 211, 33, 0.25), transparent 60%),
    radial-gradient(800px 600px at 10% 70%, rgba(44, 62, 80, 0.22), transparent 65%),
    radial-gradient(700px 700px at 90% 85%, rgba(126, 211, 33, 0.3), transparent 60%),
    linear-gradient(135deg, #ffffff 0%, #f0f9ff 25%, #e0f7fa 50%, #f1f8e9 75%, #ffffff 100%);
}

.bg::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    repeating-linear-gradient(
      45deg,
      transparent,
      transparent 100px,
      rgba(126, 211, 33, 0.03) 100px,
      rgba(126, 211, 33, 0.03) 200px
    ),
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 100px,
      rgba(44, 62, 80, 0.02) 100px,
      rgba(44, 62, 80, 0.02) 200px
    );
  animation: bgShift 20s ease-in-out infinite;
  pointer-events: none;
}

@keyframes bgShift {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(20px, 20px); }
}

.money-signs {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
}

.hero-content {
  position: relative;
  z-index: 1000;
}
.money-signs span {
  position: absolute;
  font-size: 28px;
  animation: floatMoney linear infinite;
  -webkit-user-select: none;
          user-select: none;
}

.money-signs span.green { color: rgba(126, 211, 33, 0.7); }
.money-signs span.blue { color: rgba(44, 62, 80, 0.3); }
.money-signs span.white { color: rgba(255, 255, 255, 0.5); }

.money-signs span:nth-child(1) { left: 5%; animation-duration: 16s; }
.money-signs span:nth-child(2) { left: 15%; animation-duration: 14s; animation-delay: 3s; }
.money-signs span:nth-child(3) { left: 25%; animation-duration: 18s; animation-delay: 1s; }
.money-signs span:nth-child(4) { left: 35%; animation-duration: 20s; animation-delay: 2s; }
.money-signs span:nth-child(5) { left: 45%; animation-duration: 17s; }
.money-signs span:nth-child(6) { left: 55%; animation-duration: 15s; animation-delay: 4s; }
.money-signs span:nth-child(7) { left: 65%; animation-duration: 19s; animation-delay: 1s; }
.money-signs span:nth-child(8) { left: 75%; animation-duration: 13s; animation-delay: 3s; }
.money-signs span:nth-child(9) { left: 85%; animation-duration: 21s; animation-delay: 2s; }
.money-signs span:nth-child(10) { left: 95%; animation-duration: 16s; }

@keyframes floatMoney {
  0% { transform: translateY(100vh) rotate(0deg); opacity: 0; }
  10% { opacity: 0.6; }
  90% { opacity: 0.4; }
  100% { transform: translateY(-10vh) rotate(360deg); opacity: 0; }
}

.badge {
  display: inline-block;
  padding: 8px 18px;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(44,62,80,0.15) 0%, rgba(126,211,33,0.15) 100%);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 20px;
  border: 2px solid rgba(126, 211, 33, 0.3);
  box-shadow: 0 8px 20px rgba(44,62,80,0.12);
  animation: badgePulse 3s ease-in-out infinite;
}

@keyframes badgePulse {
  0%, 100% { box-shadow: 0 8px 20px rgba(44,62,80,0.12), 0 0 0 0 rgba(126, 211, 33, 0.4); }
  50% { box-shadow: 0 8px 20px rgba(44,62,80,0.12), 0 0 0 8px rgba(126, 211, 33, 0); }
}

.hero h1 {
  font-size: 58px;
  font-weight: 800;
  line-height: 1.08;
  margin-bottom: 18px;
}

.hero h1 span { 
  background: linear-gradient(135deg, #7ED321 0%, #6BC91A 50%, #5AB015 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.hero h1 span::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, transparent, var(--green), transparent);
  border-radius: 999px;
  animation: underlineGlow 2s ease-in-out infinite;
}

@keyframes underlineGlow {
  0%, 100% { opacity: 0.5; transform: scaleX(0.8); }
  50% { opacity: 1; transform: scaleX(1); }
}

.subline {
  font-size: 18px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 14px;
}

.hero p {
  font-size: 17px;
  line-height: 1.7;
  color: #475569;
  max-width: 680px;
  margin: 0 auto 36px;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-bottom: 42px;
}

.actions button,
.actions a.primary,
.actions a.secondary {
  padding: 12px 32px;
  border-radius: 999px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  line-height: 1.5;
}

.primary { 
  background: linear-gradient(135deg, #7ED321 0%, #6BC91A 100%);
  box-shadow: 0 15px 35px rgba(126, 211, 33, 0.4);
  color: var(--blue);
  border: none;
  font-family: inherit;
  font-size: 16px;
  cursor: pointer;
}

.primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 20px 45px rgba(126, 211, 33, 0.5);
  color: #000;
  text-decoration: none;
}

.primary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(126, 211, 33, 0.3);
}

.secondary {
  background: #fff;
  border: 3px solid #66BF01;
  border-radius: 50px;
  color: #66BF01;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  padding: 14px 28px;
  box-shadow: none;
  text-align: center;
}

.secondary:hover {
  transform: translateY(-2px);
  background: rgba(102, 191, 1, 0.1);
}

.secondary:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(126, 211, 33, 0.3);
}

.pills {
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  margin: 40px 0 64px !important;
}

.pill {
  padding: 10px 18px !important;
  border-radius: 999px !important;
  background: rgba(255,255,255,0.95) !important;
  box-shadow: 0 10px 30px rgba(44,62,80,0.15) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  color: #2C3E50 !important;
  border: none !important;
  text-transform: none !important;
  letter-spacing: normal !important;
}

.pill:nth-child(odd) {
  background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(126,211,33,0.08) 100%) !important;
}

.pill:nth-child(even) {
  background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(44,62,80,0.08) 100%) !important;
}

.pill:hover {
  transform: translateY(-4px) !important;
  box-shadow: 0 15px 40px rgba(44,62,80,0.2) !important;
}

.stats {
  display: flex;
  justify-content: center;
  gap: 90px;
  margin-top: 56px !important;
  flex-wrap: wrap;
}

.stat {
  position: relative;
  padding: 20px 30px !important;
  background: rgba(255,255,255,0.95) !important;
  border-radius: 20px !important;
  box-shadow: 0 15px 35px rgba(44,62,80,0.12) !important;
  border: 2px solid rgba(126, 211, 33, 0.2) !important;
  transition: all 0.3s ease !important;
  min-width: 180px;
  text-align: center;
}

.stat::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #7ED321 0%, #2C3E50 100%) !important;
  border-radius: 20px 20px 0 0 !important;
}

.stat:hover {
  transform: translateY(-8px) !important;
  box-shadow: 0 25px 50px rgba(44,62,80,0.2) !important;
}

.stat strong {
  font-size: 28px !important;
  font-weight: 800 !important;
  background: linear-gradient(135deg, #7ED321 0%, #5AB015 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  display: block;
  line-height: 1.2;
}

.stat span {
  display: block;
  font-size: 14px !important;
  color: #475569 !important;
  margin-top: 4px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
}

/* Responsive */
@media (max-width: 1024px) {
  .hero {
    padding: 120px 6vw 20px;
  }

  .hero h1 {
    font-size: 50px;
  }

  .subline {
    font-size: 17px;
  }

  .hero p {
    font-size: 16px;
  }

  .pills {
    gap: 12px;
  }

  .pill {
    font-size: 13px !important;
    padding: 9px 16px !important;
  }
}

@media (max-width: 768px) {
  .hero {
    padding: 120px 5vw 20px;
    min-height: auto;
  }

  .badge {
    font-size: 12px;
    padding: 6px 14px;
  }

  .hero h1 {
    font-size: clamp(36px, 8vw, 44px);
    line-height: 1.15;
  }

  .subline {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .hero p {
    font-size: 15px;
    max-width: 100%;
    margin-bottom: 28px;
  }

  .actions {
    flex-direction: column;
    gap: 12px;
    margin-bottom: 32px;
    width: 100%;
  }

  .actions button,
  .actions a.primary,
  .actions a.secondary {
    width: 100%;
    padding: 14px 28px;
    font-size: 15px;
  }

  .pills {
    gap: 10px;
    margin: 30px 0 50px !important;
  }

  .pill {
    font-size: 12px !important;
    padding: 8px 14px !important;
  }

  .stats {
    gap: 60px;
  }

  .stat {
    min-width: 150px;
    padding: 16px 24px !important;
  }

  .stat strong {
    font-size: 24px !important;
  }

  .stat span {
    font-size: 13px !important;
  }

  .money-signs span {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .hero {
    padding: 110px 4vw 20px;
  }

  .badge {
    font-size: 11px;
    padding: 6px 12px;
    margin-bottom: 16px;
  }

  .hero h1 {
    font-size: clamp(28px, 7vw, 36px);
    margin-bottom: 14px;
  }

  .subline {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .hero p {
    font-size: 14px;
    margin-bottom: 24px;
    line-height: 1.6;
  }

  .actions {
    gap: 10px;
    margin-bottom: 28px;
  }

  .actions button,
  .actions a.primary,
  .actions a.secondary {
    padding: 12px 24px;
    font-size: 14px;
  }

  .pills {
    gap: 8px;
    margin: 24px 0 40px !important;
  }

  .pill {
    font-size: 11px !important;
    padding: 7px 12px !important;
  }

  .stats {
    flex-direction: column;
    gap: 20px;
    margin-top: 40px !important;
  }

  .stat {
    width: 100%;
    min-width: auto;
    padding: 14px 20px !important;
  }

  .stat strong {
    font-size: 22px !important;
  }

  .stat span {
    font-size: 12px !important;
  }

  .money-signs span {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX;;;;;;4FAM0F;AAC5F;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;;;;;;;;;;KAcG;EACH,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,gCAAgC,EAAE;AAC1C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,0BAA0B,8BAA8B,EAAE;AAC1D,yBAAyB,4BAA4B,EAAE;AACvD,0BAA0B,+BAA+B,EAAE;;AAE3D,iCAAiC,QAAQ,EAAE,uBAAuB,EAAE;AACpE,iCAAiC,SAAS,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1F,iCAAiC,SAAS,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1F,iCAAiC,SAAS,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1F,iCAAiC,SAAS,EAAE,uBAAuB,EAAE;AACrE,iCAAiC,SAAS,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1F,iCAAiC,SAAS,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1F,iCAAiC,SAAS,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1F,iCAAiC,SAAS,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1F,kCAAkC,SAAS,EAAE,uBAAuB,EAAE;;AAEtE;EACE,KAAK,yCAAyC,EAAE,UAAU,EAAE;EAC5D,MAAM,YAAY,EAAE;EACpB,MAAM,YAAY,EAAE;EACpB,OAAO,2CAA2C,EAAE,UAAU,EAAE;AAClE;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,uFAAuF;EACvF,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,WAAW,2EAA2E,EAAE;EACxF,MAAM,2EAA2E,EAAE;AACrF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0EAA0E;EAC1E,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,WAAW,YAAY,EAAE,sBAAsB,EAAE;EACjD,MAAM,UAAU,EAAE,oBAAoB,EAAE;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;EAC/C,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,6CAA6C;EAC7C,sDAAsD;EACtD,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,qGAAqG;AACvG;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,6CAA6C;EAC7C,8BAA8B;EAC9B,sDAAsD;EACtD,oDAAoD;EACpD,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uEAAuE;EACvE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,wEAAwE;EACxE,wCAAwC;EACxC,+CAA+C;EAC/C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,WAAW;EACb;;EAEA;;;IAGE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;;;IAGE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* src/components/Hero.css */\n:root {\n  --green: #7ED321;\n  --blue: #2C3E50;\n  --bg: #F5F8FB;\n}\n\n.hero {\n  position: relative;\n  z-index: 1;\n  min-height: 100vh;\n  padding: 140px 8vw 20px;\n  text-align: center;\n  max-width: 1100px;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bg {\n  position: fixed;\n  inset: 0;\n  z-index: -1;\n  background:\n    radial-gradient(1200px 800px at 20% 15%, rgba(126, 211, 33, 0.35), transparent 55%),\n    radial-gradient(1100px 900px at 80% 25%, rgba(44, 62, 80, 0.28), transparent 55%),\n    radial-gradient(900px 700px at 50% 80%, rgba(126, 211, 33, 0.25), transparent 60%),\n    radial-gradient(800px 600px at 10% 70%, rgba(44, 62, 80, 0.22), transparent 65%),\n    radial-gradient(700px 700px at 90% 85%, rgba(126, 211, 33, 0.3), transparent 60%),\n    linear-gradient(135deg, #ffffff 0%, #f0f9ff 25%, #e0f7fa 50%, #f1f8e9 75%, #ffffff 100%);\n}\n\n.bg::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    repeating-linear-gradient(\n      45deg,\n      transparent,\n      transparent 100px,\n      rgba(126, 211, 33, 0.03) 100px,\n      rgba(126, 211, 33, 0.03) 200px\n    ),\n    repeating-linear-gradient(\n      -45deg,\n      transparent,\n      transparent 100px,\n      rgba(44, 62, 80, 0.02) 100px,\n      rgba(44, 62, 80, 0.02) 200px\n    );\n  animation: bgShift 20s ease-in-out infinite;\n  pointer-events: none;\n}\n\n@keyframes bgShift {\n  0%, 100% { transform: translate(0, 0); }\n  50% { transform: translate(20px, 20px); }\n}\n\n.money-signs {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 1000;\n}\n.money-signs span {\n  position: absolute;\n  font-size: 28px;\n  animation: floatMoney linear infinite;\n  user-select: none;\n}\n\n.money-signs span.green { color: rgba(126, 211, 33, 0.7); }\n.money-signs span.blue { color: rgba(44, 62, 80, 0.3); }\n.money-signs span.white { color: rgba(255, 255, 255, 0.5); }\n\n.money-signs span:nth-child(1) { left: 5%; animation-duration: 16s; }\n.money-signs span:nth-child(2) { left: 15%; animation-duration: 14s; animation-delay: 3s; }\n.money-signs span:nth-child(3) { left: 25%; animation-duration: 18s; animation-delay: 1s; }\n.money-signs span:nth-child(4) { left: 35%; animation-duration: 20s; animation-delay: 2s; }\n.money-signs span:nth-child(5) { left: 45%; animation-duration: 17s; }\n.money-signs span:nth-child(6) { left: 55%; animation-duration: 15s; animation-delay: 4s; }\n.money-signs span:nth-child(7) { left: 65%; animation-duration: 19s; animation-delay: 1s; }\n.money-signs span:nth-child(8) { left: 75%; animation-duration: 13s; animation-delay: 3s; }\n.money-signs span:nth-child(9) { left: 85%; animation-duration: 21s; animation-delay: 2s; }\n.money-signs span:nth-child(10) { left: 95%; animation-duration: 16s; }\n\n@keyframes floatMoney {\n  0% { transform: translateY(100vh) rotate(0deg); opacity: 0; }\n  10% { opacity: 0.6; }\n  90% { opacity: 0.4; }\n  100% { transform: translateY(-10vh) rotate(360deg); opacity: 0; }\n}\n\n.badge {\n  display: inline-block;\n  padding: 8px 18px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, rgba(44,62,80,0.15) 0%, rgba(126,211,33,0.15) 100%);\n  font-weight: 600;\n  font-size: 14px;\n  margin-bottom: 20px;\n  border: 2px solid rgba(126, 211, 33, 0.3);\n  box-shadow: 0 8px 20px rgba(44,62,80,0.12);\n  animation: badgePulse 3s ease-in-out infinite;\n}\n\n@keyframes badgePulse {\n  0%, 100% { box-shadow: 0 8px 20px rgba(44,62,80,0.12), 0 0 0 0 rgba(126, 211, 33, 0.4); }\n  50% { box-shadow: 0 8px 20px rgba(44,62,80,0.12), 0 0 0 8px rgba(126, 211, 33, 0); }\n}\n\n.hero h1 {\n  font-size: 58px;\n  font-weight: 800;\n  line-height: 1.08;\n  margin-bottom: 18px;\n}\n\n.hero h1 span { \n  background: linear-gradient(135deg, #7ED321 0%, #6BC91A 50%, #5AB015 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  position: relative;\n}\n\n.hero h1 span::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, var(--green), transparent);\n  border-radius: 999px;\n  animation: underlineGlow 2s ease-in-out infinite;\n}\n\n@keyframes underlineGlow {\n  0%, 100% { opacity: 0.5; transform: scaleX(0.8); }\n  50% { opacity: 1; transform: scaleX(1); }\n}\n\n.subline {\n  font-size: 18px;\n  font-weight: 600;\n  color: #334155;\n  margin-bottom: 14px;\n}\n\n.hero p {\n  font-size: 17px;\n  line-height: 1.7;\n  color: #475569;\n  max-width: 680px;\n  margin: 0 auto 36px;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  gap: 18px;\n  margin-bottom: 42px;\n}\n\n.actions button,\n.actions a.primary,\n.actions a.secondary {\n  padding: 12px 32px;\n  border-radius: 999px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n  line-height: 1.5;\n}\n\n.primary { \n  background: linear-gradient(135deg, #7ED321 0%, #6BC91A 100%);\n  box-shadow: 0 15px 35px rgba(126, 211, 33, 0.4);\n  color: var(--blue);\n  border: none;\n  font-family: inherit;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.primary:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 20px 45px rgba(126, 211, 33, 0.5);\n  color: #000;\n  text-decoration: none;\n}\n\n.primary:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(126, 211, 33, 0.3);\n}\n\n.secondary {\n  background: #fff;\n  border: 3px solid #66BF01;\n  border-radius: 50px;\n  color: #66BF01;\n  display: inline-flex;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.5;\n  padding: 14px 28px;\n  box-shadow: none;\n  text-align: center;\n}\n\n.secondary:hover {\n  transform: translateY(-2px);\n  background: rgba(102, 191, 1, 0.1);\n}\n\n.secondary:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(126, 211, 33, 0.3);\n}\n\n.pills {\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin: 40px 0 64px !important;\n}\n\n.pill {\n  padding: 10px 18px !important;\n  border-radius: 999px !important;\n  background: rgba(255,255,255,0.95) !important;\n  box-shadow: 0 10px 30px rgba(44,62,80,0.15) !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n  transition: all 0.3s ease !important;\n  color: #2C3E50 !important;\n  border: none !important;\n  text-transform: none !important;\n  letter-spacing: normal !important;\n}\n\n.pill:nth-child(odd) {\n  background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(126,211,33,0.08) 100%) !important;\n}\n\n.pill:nth-child(even) {\n  background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(44,62,80,0.08) 100%) !important;\n}\n\n.pill:hover {\n  transform: translateY(-4px) !important;\n  box-shadow: 0 15px 40px rgba(44,62,80,0.2) !important;\n}\n\n.stats {\n  display: flex;\n  justify-content: center;\n  gap: 90px;\n  margin-top: 56px !important;\n  flex-wrap: wrap;\n}\n\n.stat {\n  position: relative;\n  padding: 20px 30px !important;\n  background: rgba(255,255,255,0.95) !important;\n  border-radius: 20px !important;\n  box-shadow: 0 15px 35px rgba(44,62,80,0.12) !important;\n  border: 2px solid rgba(126, 211, 33, 0.2) !important;\n  transition: all 0.3s ease !important;\n  min-width: 180px;\n  text-align: center;\n}\n\n.stat::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #7ED321 0%, #2C3E50 100%) !important;\n  border-radius: 20px 20px 0 0 !important;\n}\n\n.stat:hover {\n  transform: translateY(-8px) !important;\n  box-shadow: 0 25px 50px rgba(44,62,80,0.2) !important;\n}\n\n.stat strong {\n  font-size: 28px !important;\n  font-weight: 800 !important;\n  background: linear-gradient(135deg, #7ED321 0%, #5AB015 100%) !important;\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n  display: block;\n  line-height: 1.2;\n}\n\n.stat span {\n  display: block;\n  font-size: 14px !important;\n  color: #475569 !important;\n  margin-top: 4px !important;\n  font-weight: 600 !important;\n  text-transform: none !important;\n  letter-spacing: normal !important;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .hero {\n    padding: 120px 6vw 20px;\n  }\n\n  .hero h1 {\n    font-size: 50px;\n  }\n\n  .subline {\n    font-size: 17px;\n  }\n\n  .hero p {\n    font-size: 16px;\n  }\n\n  .pills {\n    gap: 12px;\n  }\n\n  .pill {\n    font-size: 13px !important;\n    padding: 9px 16px !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero {\n    padding: 120px 5vw 20px;\n    min-height: auto;\n  }\n\n  .badge {\n    font-size: 12px;\n    padding: 6px 14px;\n  }\n\n  .hero h1 {\n    font-size: clamp(36px, 8vw, 44px);\n    line-height: 1.15;\n  }\n\n  .subline {\n    font-size: 16px;\n    margin-bottom: 12px;\n  }\n\n  .hero p {\n    font-size: 15px;\n    max-width: 100%;\n    margin-bottom: 28px;\n  }\n\n  .actions {\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 32px;\n    width: 100%;\n  }\n\n  .actions button,\n  .actions a.primary,\n  .actions a.secondary {\n    width: 100%;\n    padding: 14px 28px;\n    font-size: 15px;\n  }\n\n  .pills {\n    gap: 10px;\n    margin: 30px 0 50px !important;\n  }\n\n  .pill {\n    font-size: 12px !important;\n    padding: 8px 14px !important;\n  }\n\n  .stats {\n    gap: 60px;\n  }\n\n  .stat {\n    min-width: 150px;\n    padding: 16px 24px !important;\n  }\n\n  .stat strong {\n    font-size: 24px !important;\n  }\n\n  .stat span {\n    font-size: 13px !important;\n  }\n\n  .money-signs span {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero {\n    padding: 110px 4vw 20px;\n  }\n\n  .badge {\n    font-size: 11px;\n    padding: 6px 12px;\n    margin-bottom: 16px;\n  }\n\n  .hero h1 {\n    font-size: clamp(28px, 7vw, 36px);\n    margin-bottom: 14px;\n  }\n\n  .subline {\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n\n  .hero p {\n    font-size: 14px;\n    margin-bottom: 24px;\n    line-height: 1.6;\n  }\n\n  .actions {\n    gap: 10px;\n    margin-bottom: 28px;\n  }\n\n  .actions button,\n  .actions a.primary,\n  .actions a.secondary {\n    padding: 12px 24px;\n    font-size: 14px;\n  }\n\n  .pills {\n    gap: 8px;\n    margin: 24px 0 40px !important;\n  }\n\n  .pill {\n    font-size: 11px !important;\n    padding: 7px 12px !important;\n  }\n\n  .stats {\n    flex-direction: column;\n    gap: 20px;\n    margin-top: 40px !important;\n  }\n\n  .stat {\n    width: 100%;\n    min-width: auto;\n    padding: 14px 20px !important;\n  }\n\n  .stat strong {\n    font-size: 22px !important;\n  }\n\n  .stat span {\n    font-size: 12px !important;\n  }\n\n  .money-signs span {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
